export default (value, [max]) => {
  if (value === undefined || value === null) {
    return false
  }
  if (!Array.isArray(value)) {
    return false
  }
  return value.length <= max
}
